module.exports = _.remove;